var map = {
	"./ali.jpg": "bbe4",
	"./ali_1x1.jpg": "61d2e",
	"./ali_1x1.webp": "d696",
	"./aya.jpg": "37bf",
	"./aya_1x1.jpg": "7357",
	"./aya_1x1.webp": "a6a4",
	"./gina.jpg": "b998",
	"./gina_1x1.jpg": "1836",
	"./gina_1x1.webp": "861f",
	"./joshua_1x1.jpg": "8796",
	"./joshua_1x1.webp": "8d32",
	"./lisa.jpg": "f402",
	"./lisa_1x1.jpg": "4e33",
	"./lisa_1x1.webp": "af12",
	"./niklas.jpg": "40f3",
	"./niklas_1x1.jpg": "3e9a",
	"./niklas_1x1.webp": "c35c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b270";